import { Card, Col, Divider, Row, Spin, Tag, Typography } from 'antd'
import React from 'react'
import { connect } from 'react-redux'

import dayjs from "dayjs"
import { withRouter } from 'react-router'
import { getArtistPermissions, getArtistsAdmin } from "../../api/artists"
import { getAllUserAdmin } from "../../api/user"
import '../../asset/less/NewPieces.css'
import GalleryTablePanel from "../../component/GalleryTablePanel"
import { getEditUrl } from '../../component/Utils'
import { URL_ADMIN_EDIT_USER_ID } from "../../const"

const {Title} = Typography
const {Meta} = Card

@connect((state) => ({
    userId: state.user.info.id,
    email: state.user.info.email,
    role: state.user.info.role,
    artists: state.artist.artists,
}))
class UserListAdmin extends React.Component {
    constructor(props) {
        super(props)
        this.expoFormRef = React.createRef()
        this.formRef = React.createRef()
        this.state = {
            loading: true,
            namesMap: {},
            userMap: {},
            permissionMap: {},
        }

        this.dummyColumns = [
            {
                title: 'user_id',
                dataIndex: 'id',
                key: 'id',
                width: '60px',
            },
            {
                title: 'artist_id',
                dataIndex: 'artist_id',
                key: 'artist_id',
                width: '60px',
            },
            {
                title: 'Email',
                dataIndex: 'email',
                key: 'email',
                width: "14%"
            },
            {
                title: 'Approved',
                dataIndex: 'is_approved',
                key: 'is_approved',
                render: (text, record) => {
                    if(text) {
                        return <Tag>{"Approved"}</Tag>
                    }else{
                        return "N"
                    }
                },
            },
            {
                title: 'Pending',
                dataIndex: 'is_pending_approve',
                key: 'is_pending_approve',
                render: (text, record) => {
                    if(text) {
                        return "Y"
                    }else{
                        return "N"
                    }
                },
            },
            {
                title: 'First Name',
                dataIndex: 'first_name',
                key: 'first_name',
                sorter: (a, b) => a.first_name.localeCompare(b.first_name)
            },
            {
                title: 'Last Name',
                dataIndex: 'last_name',
                key: 'last_name',
                sorter: (a, b) => a.last_name.localeCompare(b.last_name)
            },
            {
                title: 'Last Login',
                dataIndex: 'last_login',
                key: 'last_login',
                render: (text, record) => {
                    if (!text) {
                        return
                    }
                    return dayjs(text).format("MM/DD/YY")
                },
                sorter: (a, b) => dayjs(a.last_login).isAfter(dayjs(b.last_login))
            },
            {
                title: 'Create At',
                dataIndex: 'created_at',
                key: 'created_at',
                render: (text, record) => {
                    if (!text) {
                        return
                    }
                    return dayjs(text).format("MM/DD/YY")
                },
                sorter: (a, b) => dayjs(a.created_at).isAfter(dayjs(b.created_at))
            }
        ]

        this.dummyFilterOptions = [
        ]

        this.dummySortOptions = [
        ]

        this.namesMap = {}
        props.artists?.forEach((name)=>{
            this.namesMap[name.artist] = name
        })
    }

    async componentDidMount() {
        const [permissions, users] = await Promise.all([getArtistPermissions(1, 100000),
            getAllUserAdmin(1, 100000)])
        let permissionMap = {}
        permissions.data.results?.forEach((permission) => {
            permissionMap[permission.artist] = permission
        })
        let userMap = {}
        console.log(users.data)
        users.data.results?.forEach((user) => {
            userMap[user.id] = user
        })
        this.setState({
            loading: false,
            userMap: userMap,
            permissionMap: permissionMap
        })
    }

    requestData = (pageId, pageSize, sort, filters, search) => {
        // prepare your data from Apis or local tests

        return new Promise(async (resolve, reject)=> {
           try {
               const artists = await getArtistsAdmin(pageId, pageSize)
               const mappedData = artists.data?.results?.map((artist)=>{
                   const permission = this.state.permissionMap[artist.id]
                   const user = this.state.userMap[artist.user]
                   return {
                        first_name: this.namesMap[artist.id]?.first_name,
                        last_name: this.namesMap[artist.id]?.last_name,
                        is_approved: permission?.is_approved,
                        email: user?.email,
                        is_pending_approve: permission?.is_pending_approve,
                        last_login: user?.last_login,
                        ...artist,
                        id: artist.user,
                        artist_id: artist.id,
                    }
               })
               resolve({
                   data: {
                       count: artists.data?.count,
                       next: artists.data?.next,
                       previous: artists.data?.previous,
                       results: mappedData
                   }
               })
           }catch (e) {
               reject(e)
           }
        })
    }

    getEditUrl = (element) => {
        if (!element.id) {
            return
        }

        return getEditUrl(URL_ADMIN_EDIT_USER_ID, element.id)
    }

    deleteData = (id) => {
        return new Promise((resolve, reject)=>{
            reject("Not implemented")
        })
    }

    render() {
        return (
            <Spin size='large' spinning={this.state.loading}>
                <div className='site-layout-background'>
                    <Row align='middle' gutter={{xs: 8, sm: 16, md: 24}}>
                        <Col>
                            <Title style={{marginBottom: 0}}>User List</Title>
                        </Col>
                    </Row>
                    <Divider style={{marginBottom: 12, marginTop: 12}}/>
                    {!this.state.loading && (
                        <GalleryTablePanel name={'userListAdmin'} requestData={this.requestData}
                                       columns={this.dummyColumns} tableWidth={1200}
                                       viewOptions={['table']} disableSearch={true}
                                       pageSizeOptions={[10, 20, 50, 100, 1000]} addNewUrl={''}
                                       getEditUrl={this.getEditUrl} deleteData={null}
                                       sortOptions={this.dummySortOptions} defaultSortOption={this.dummySortOptions[0]}
                                       filterOptions={this.dummyFilterOptions}/>
                    )}
                </div>
            </Spin>
        )
    }
}

export default withRouter(UserListAdmin)